import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Clock, LogOut } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="sg-noise flex min-h-screen items-center justify-center bg-[#0A0A0A] px-6">
      <div className="relative z-10 w-full max-w-lg text-center" data-testid="pending-approval">
        <div className="mx-auto mb-10 flex h-10 justify-center">
          <Logo className="h-10" />
        </div>
        <div className="rounded-2xl border border-white/[0.06] bg-[#141414] p-10">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-400">
            <Clock className="h-7 w-7" />
          </span>
          <h1 className="mt-6 font-display text-2xl font-semibold tracking-tight text-white">
            Account awaiting approval
          </h1>
          <p className="mt-4 text-base leading-relaxed text-neutral-400">
            Your account is currently awaiting approval from SGBINOXE. You'll be able to access your
            workspace as soon as the team activates your account.
          </p>
          {user && (
            <div className="mt-6 rounded-xl border border-white/[0.06] bg-[#0A0A0A] p-4 text-left">
              <p className="text-xs uppercase tracking-[0.15em] text-neutral-600">Registered business</p>
              <p className="mt-1 font-medium text-white">{user.business_name}</p>
              <p className="text-sm text-neutral-500">{user.email}</p>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="mt-8 inline-flex items-center gap-2 rounded-lg border border-white/[0.1] px-5 py-2.5 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:bg-white/[0.05] hover:text-white"
            data-testid="pending-logout"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
